import { AWARD_PAGE } from './actionTypes';

const getAwardData = (vertical_id, project_url_slug) => (
  dispatch,
  getState,
  { api }
) => {
  dispatch({
    type: AWARD_PAGE.AWARD_PAGE_REQUEST,
    payload: {},
    test: api
      .post(`awards.json`)
      .then(res => {
        const awards_data = {
          vertical_id: vertical_id,
          project_url_slug: project_url_slug,
          data: res.data.data || null,
        };
        dispatch({
          type: AWARD_PAGE.AWARD_PAGE_SUCCESS,
          payload: awards_data,
        });
      })
      .catch(error => {
        dispatch({
          type: AWARD_PAGE.AWARD_PAGE_FAILURE,
          error,
        });
      }),
  });
};

export const AwardActions = {
  getAwardData,
};
